// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-PGe1M {\n  all: initial;\n  font: inherit;\n  box-sizing: inherit;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  z-index: 1005;\n  outline: 0;\n}\n.wrap-rJsY\\+ {\n  position: absolute;\n  z-index: 9999;\n  left: 10px;\n  top: 10px;\n}\n.content-9rSwR {\n  border: 2px solid #4a4a4a;\n}\n.content-9rSwR .header-jof8W {\n  height: 0;\n  min-height: 0;\n  padding: 0;\n  border: none;\n  z-index: 5;\n}\n.content-9rSwR .header-jof8W .closeButton-jAJN4 {\n  z-index: 5;\n}\n.content-9rSwR .main-fJkAl {\n  max-height: none;\n}\n.content-9rSwR .main-fJkAl .mainContent-TKPOD {\n  padding: 0;\n  margin: 0;\n  max-height: 90vh;\n  cursor: move;\n}\n.content-9rSwR .footer-HqCCp {\n  display: none;\n}\n", "",{"version":3,"sources":["webpack://./app/EAssessment.UI.Common/app-components/dialogs/image-draggable-dialog/draggableDialog.less"],"names":[],"mappings":"AAIA;EAEI,YAAA;EACA,aAAA;EACA,mBAAA;EAEA,kBAAA;EACA,kBAAA;EAEA,aAAA;EAEA,UAAA;AA6GJ;AAxHA;EAeI,kBAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;AA4GJ;AA9HA;EAsBI,yBAAA;AA2GJ;AAjIA;EAyBM,SAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;AA2GN;AAxIA;EAgCQ,UAAA;AA2GR;AA3IA;EAqCM,gBAAA;AAyGN;AA9IA;EAwCQ,UAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;AAyGR;AApJA;EAgDM,aAAA;AAuGN","sourcesContent":["@import '@cirrus/legacy/app-components/app/styles/font-size-variables.less';\n@import '@cirrus/legacy/app-components/app/styles/colors/colors-default.less';\n@import '../dialog/variables';\n\n:local {\n  .modal {\n    all: initial;\n    font: inherit;\n    box-sizing: inherit;\n\n    overflow-x: hidden;\n    overflow-y: hidden;\n\n    z-index: @dialog-z-index;\n\n    outline: 0;\n  }\n\n  .wrap {\n    position: absolute;\n    z-index: 9999;\n    left: 10px;\n    top: 10px;\n  }\n\n  .content {\n    border: 2px solid @clr-gray-800;\n\n    .header {\n      height: 0;\n      min-height: 0;\n      padding: 0;\n      border: none;\n      z-index: @dialog-footer-header-z-index;\n\n      .closeButton {\n        z-index: @dialog-footer-header-z-index;\n      }\n    }\n\n    .main {\n      max-height: none;\n\n      .mainContent {\n        padding: 0;\n        margin: 0;\n        max-height: 90vh;\n        cursor: move;\n      }\n    }\n\n    .footer {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageTitleFontSize": "22px",
	"pageTitleLineHeight": "55px",
	"white": "#fff",
	"black": "#000",
	"yellow": "#008859",
	"yellowinprogress": "#BEA66E",
	"blackt30": "rgba(0, 0, 0, 0.3)",
	"black50": "rgba(0, 0, 0, 0.75)",
	"blue100": "#4690d1",
	"blue120": "#2791c6",
	"blue130": "#2196f3",
	"blue150": "#add2f7",
	"blue210": "#287ec7",
	"blue300": "#0478c6",
	"blue400": "#024b7b",
	"blue330": "#0055b0",
	"brown310": "#7f707d",
	"red": "red",
	"red70": "#f7bfb9",
	"red100": "#e87d7d",
	"red300": "#f35958",
	"red320": "#e05251",
	"red405": "#a94442",
	"red410": "#bc2b43",
	"red500": "#cc2d30",
	"red550": "#c60000",
	"red900": "#ff0000",
	"red905": "#cf4444",
	"red910": "#c60000",
	"green200": "#d8f0ea",
	"green210": "#c0e8dc",
	"green250": "#09998d",
	"green270": "#47bcb3",
	"green300": "#008859",
	"green310": "#4cb992",
	"green505": "#119264",
	"green520": "#00794f",
	"green650": "#b1dac6",
	"green700": "#008000",
	"green710": "#30b382",
	"green800": "#008859",
	"yellow90": "#fbdba0",
	"yellow410": "#fedb97",
	"orange200": "#eda04f",
	"orange300": "#ee9a02",
	"orange350": "#e7a257",
	"orange360": "#c3a565",
	"orange380": "#ff8c40",
	"orange400": "#ef7400",
	"orange420": "#ff6600",
	"orange550": "#bf5000",
	"blue170": "#7e9fc2",
	"blue220": "#537fad",
	"blue250": "#2879c7",
	"darkBlue400": "#272c40",
	"blue305": "#0055b0",
	"blue310": "#00829b",
	"brown320": "#7f707d",
	"gray75": "#f6f6f6",
	"gray80": "#eeeeee",
	"gray85": "#ecedec",
	"gray95": "#d9d9d9",
	"gray120": "#e5e9ec",
	"gray200": "#dddddd",
	"gray201": "#f2f2f2",
	"gray214": "#c4c4c4",
	"gray215": "#cccccc",
	"gray220": "#ccd0d3",
	"gray225": "#c1c9cd",
	"gray240": "#cfcfcf",
	"gray230": "#d9edf7",
	"gray245": "#8b8b8b",
	"gray250": "#808080",
	"gray320": "#dedce0",
	"gray400": "#5e5e5e",
	"gray420": "#555555",
	"gray850": "#554854",
	"gray305": "#757575",
	"gray500": "#333333",
	"gray800": "#4a4a4a",
	"gray820": "#40465d",
	"gray855": "#8b91a0",
	"gray280": "#999999",
	"gray50": "#f9f9f9",
	"gray100": "#ececec",
	"gray125": "#e4e4e4",
	"gray235": "#c1bebe",
	"gray350": "#6b546a",
	"gray600": "#f1f1f1",
	"gray720": "#b6b6b6",
	"gray740": "#b6a8b4",
	"gray755": "#ebebeb",
	"gray810": "#525252",
	"gray860": "#9b9b9b",
	"gray870": "#929292",
	"gray890": "#756372",
	"gray895": "#989898",
	"gray910": "#444059",
	"gray925": "#9c9c9c",
	"gray930": "#ddcfac",
	"gray935": "#5f6368",
	"gray920": "#757575",
	"gray950": "#ece4d0",
	"gray1000": "#ebe8e8",
	"gray1010": "#e6e6e6",
	"gray1050": "#e0e6f0",
	"gray1060": "#c6c6c6",
	"gray1100": "#ededed",
	"gray1120": "#8e818c",
	"gray1150": "#212121",
	"purple": "#6a546a",
	"transparent": "transparent",
	"modal": "modal-PGe1M",
	"wrap": "wrap-rJsY+",
	"content": "content-9rSwR",
	"header": "header-jof8W",
	"closeButton": "closeButton-jAJN4",
	"main": "main-fJkAl",
	"mainContent": "mainContent-TKPOD",
	"footer": "footer-HqCCp"
};
export default ___CSS_LOADER_EXPORT___;
